import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { DependencyUsage, IssueFilterKeys } from '../../../../shared/issuesV2';
import * as IssuesV2Store from '../../../redux/issuesV2';
import { useSetFilterHasChanged } from '../../../redux/savedFilters/hooks';
import { FilterPanel } from '../../generic/Filter';
import FilterCardCheckboxes from '../../generic/Filter/FilterCardCheckboxes';
import useFetchIssuesAction from '../IssuesInbox/hooks/useFetchIssuesAction';
import type { SelectOption } from '../../../types';
import type { SelectedOptionsProps } from '../../generic/Filter';

const FILTER_OPTIONS: SelectOption[] = [
  { value: DependencyUsage.Direct, label: 'Direct' },
  { value: DependencyUsage.Deep, label: 'Transitive' },
];

const DepthIssueFilter: VoidFunctionComponent<Omit<SelectedOptionsProps, 'onSelect'>> = ({ selectedOptions }) => {
  const setFilters = useFetchIssuesAction(IssuesV2Store.actions.setFilter);
  const stateFilters = useSelector(IssuesV2Store.selectors.getFilter);
  const setFilterHasChanged = useSetFilterHasChanged();

  const selectedCheckboxes = (selectedOptions ?? []).map((option: string) => ({
    label: FILTER_OPTIONS.find(filterOption => filterOption.value === option)?.label || option,
    value: option,
  }));

  const onCheckboxChange = (newSelected: SelectOption[]) => {
    setFilters({
      ...stateFilters,
      [IssueFilterKeys.Depths]: newSelected.map(({ value }) => value as DependencyUsage),
    });
    setFilterHasChanged(true);
  };

  return (
    <FilterPanel>
      <FilterCardCheckboxes
        label="Depth"
        options={FILTER_OPTIONS}
        values={selectedCheckboxes}
        onChange={onCheckboxChange}
        testId="issues-depth-filters"
      />
    </FilterPanel>
  );
};

export default DepthIssueFilter;
